export default function capitalize(string) {
  // search words separated by whitespace or '-' and capitalize their first letter
  return string.replaceAll(/\w*[^-/|\s]*/g, (w) => (
    w.replace(/^\w/, (c) => c.toUpperCase()
    )));
}